<template>
  <header :class='{nav_fixed: isFixedNavBar}'>
    <div class='w_1200 cf'>
      <div class='fl'>
        <router-link to='/' class='logo img_box dis_ib ver_m nav-item'>
          <img src='./../assets/icons/logo_tab@2x.png' alt=''>
        </router-link>
        <ul class='menu_box dis_ib ver_m'>
          <li>
            <router-link class='nav-item' to='/goods'>{{ $t('home.navigation.goods') }}</router-link>
          </li>
          <li>
            <a href='#'>{{ $t('home.navigation.reading') }}</a>
            <div class='slide_menu hide'>
              <div class='tit'>{{ $t('reading.categoryTitle') }}</div>
              <div class='fz_0'>
                <div class='menu_item '>
                  <div class='item'>
                    <router-link class='nav-item' to='/talkingPen'>
                      <a href=''>
                        <div class='img_box dis_ib ver_m'>
                          <img src='./../assets/icons/ic_logo_maomao_o@2x.png' alt=''>
                        </div>
                        <div class='name dis_ib ver_m'>{{ $t('reading.talkingPen.category') }}</div>
                      </a>
                    </router-link>
                  </div>
                  <div class='item'>
                    <router-link class='nav-item' to='/highFive'>
                      <a href=''>
                        <div class='img_box dis_ib ver_m'>
                          <img src='./../assets/icons/ic_logo_highfive_o@2x.png' alt=''>
                        </div>
                        <div class='name dis_ib ver_m'>{{ $t('reading.highfiveClass.category') }}</div>
                      </a>
                    </router-link>
                  </div>
                </div>
                <div class='menu_item'>
                  <div class='item'>
                    <router-link class='nav-item' to='/listenEnglish'>
                      <a href=''>
                        <div class='img_box dis_ib ver_m'>
                          <img src='@/assets/icons/Group3@2x (2).png' style='border-radius: 50%;' alt=''></div>
                        <div class='name dis_ib ver_m'>{{ $t('reading.funEnglish.category') }}</div>
                      </a>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li>
            <router-link class='nav-item' to='/business-cooperate'>{{ $t('home.navigation.bussiniss') }}</router-link>
          </li>
          <li>
            <router-link class='nav-item' to='/profession'>{{ $t('home.navigation.profession') }}</router-link>
          </li>
          <li>
            <router-link class='nav-item' to='/about'>{{ $t('home.navigation.about') }}</router-link>
          </li>
        </ul>
      </div>
      <div class='fr'>
        <div class='nav-item language' @click='changeLanguage($t("language.other.type"))'>{{ $t('language.other.text') }}</div>
        <!--        <a class='nav-item login' href='#'>{{ $t('home.loginButton.login') }}</a>-->
        <!--        <a class='nav-item register' href='#'>{{ $t('home.loginButton.register') }}</a>-->
        <div class='menu_btn iconfont iconic_mobile_more' @click='showLeftNavbar'></div>
      </div>
    </div>

    <!-- ipad菜单 -->
    <div class='dialog_menu' :class='{slide_in_right: isShowNav}'>
      <div class='top'>
        <div class='s_logo img_box' @click='goPage("/")'>
          <img src='./../assets/icons/ipad_logo.png' alt=''>
        </div>
        <div class='close' @click='showLeftNavbar'>
          <span class='icon'></span>
          <i class='iconfont close_btn iconic_mobile_down'></i>
        </div>
      </div>
      <div class='line'></div>
      <ul>
        <li>
          <div class='nav-item' @click='goPage("/goods")'>{{ $t('home.navigation.goods') }}</div>
        </li>
        <li>
          <div class='sub-title'>{{ $t('home.navigation.reading') }}</div>
          <div class='slide_box'>
            <div class='tit'>{{ $t('reading.categoryTitle') }}</div>
            <div class='slide_info'>
              <div class='item'>
                <div class='nav-item' @click='goPage("/talkingPen")'>
                  <i>
                    <img src='@/assets/icons/ic_logo_maomao_o@2x.png'>
                  </i>
                  <span>{{ $t('reading.talkingPen.category') }}</span>
                </div>
              </div>
              <div class='item'>
                <div class='nav-item' @click='goPage("/listenEnglish")'>
                  <i>
                    <img src='@/assets/icons/Group3@2x (2).png'>
                  </i>
                  <span>{{ $t('reading.funEnglish.category') }}</span>
                </div>
              </div>
              <div class='item'>
                <div class='nav-item' @click='goPage("/highFive")'>
                  <i>
                    <img src='@/assets/icons/ic_logo_highfive_o@2x.png'>
                  </i>
                  <span>{{ $t('reading.highfiveClass.category') }}</span>
                </div>
              </div>
            </div>
          </div>
        </li>
        <li>
          <div class='nav-item' @click='goPage("/business-cooperate")'>{{ $t('home.navigation.bussiniss') }}</div>
        </li>
        <li>
          <div class='nav-item' @click='goPage("/profession")'>{{ $t('home.navigation.profession') }}</div>
        </li>
        <li>
          <div class='nav-item' @click='goPage("/about")'>{{ $t('home.navigation.about') }}</div>
        </li>
      </ul>
    </div>
  </header>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'TopNavbar',
  data () {
    return {
      isShowNav: false,
    }
  },
  computed: {
    ...mapState(['isFixedNavBar']),
  },
  methods: {
    changeLanguage (type) {
      this.$i18n.locale = type
    },
    showLeftNavbar () {
      if (this.isShowNav) {
        document.body.className = ''
        this.isShowNav = false
      } else {
        document.body.className = 'fixed'
        this.isShowNav = true
      }
    },
    goPage (url) {
      document.body.className = ''
      this.isShowNav = false
      this.$router.push(url)
    },
    goBack () {
      document.body.className = ''
      this.isShowNav = false
    },
  },
  mounted () {
    if (window.history && window.history.pushState) {
      // 向历史记录中插入了当前页
      history.pushState(null, null, document.URL)
      window.addEventListener('popstate', this.goBack, false)
    }
  },
  destroyed () {
    window.removeEventListener('popstate', this.goBack, false)
  },
}
</script>
